import { Skeleton } from "@mui/material";
import Header from "../components/details/DetailHeader";

const AdminDashboardSkeleton = () => {
  return (
    <div className="container mx-auto mt-3 mb-10 px-4">
      {/* Sticky Header */}
      <div className="sticky top-0 z-10">
        <Header />
      </div>

      {/* Dashboard Header */}
      <div className="mb-6 flex items-center justify-between">
        <Skeleton variant="text" width={200} height={36} />
        <Skeleton variant="rounded" width={200} height={36} />
      </div>

      {/* KPI CARDS */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 mb-6">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="relative rounded-xl border bg-white p-4">
            {/* Icon */}
            <Skeleton
              variant="rounded"
              width={24}
              height={24}
              className="absolute right-4 top-4"
            />

            {/* Title */}
            <Skeleton variant="text" width="60%" height={14} />

            {/* Value */}
            <Skeleton variant="text" width="40%" height={32} className="mt-2" />

            {/* Subtitle */}
            <Skeleton variant="text" width="80%" height={12} />
          </div>
        ))}
      </div>

      {/* MAIN CONTENT */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[2fr_1fr]">
        {/* DAMAGE DISTRIBUTION */}
        <div className="rounded-xl border bg-white p-6">
          <Skeleton variant="text" width={220} height={24} />
          <Skeleton variant="text" width={260} height={14} className="mb-6" />

          {/* Horizontal bars */}
          <div className="space-y-6 mb-8">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="flex items-center gap-4">
                <Skeleton variant="text" width={60} height={14} />
                <Skeleton variant="rounded" width="100%" height={20} />
              </div>
            ))}
          </div>

          {/* Legend cards */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="rounded-lg bg-gray-50 p-4">
                <Skeleton variant="text" width={60} height={14} />
                <Skeleton variant="text" width={80} height={20} />
                <Skeleton variant="text" width={40} height={12} />
              </div>
            ))}
          </div>
        </div>

        {/* PROJECT STATUS */}
        <div className="rounded-xl border bg-white p-6">
          <Skeleton variant="text" width={160} height={24} />
          <Skeleton variant="text" width={200} height={14} className="mb-4" />

          {/* Total projects */}
          <Skeleton variant="text" width={100} height={36} className="mb-4" />

          {/* Progress bar */}
          <Skeleton
            variant="rounded"
            width="100%"
            height={10}
            className="mb-6"
          />

          {/* Status rows */}
          <div className="space-y-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="flex items-center justify-between rounded-lg bg-gray-50 p-4"
              >
                <div className="flex items-center gap-3">
                  <Skeleton variant="circular" width={24} height={24} />
                  <div>
                    <Skeleton variant="text" width={90} height={14} />
                    <Skeleton variant="text" width={70} height={12} />
                  </div>
                </div>
                <Skeleton variant="text" width={30} height={20} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardSkeleton;
